import { get } from "lodash";

export enum EligibilityCheck {
  MUST_CHECK = "MUST_CHECK",
  BYPASS = "BYPASS",
  EXEMPT = "EXEMPT",
}
export class EligibilityOverride {
  application_uuid: string;
  hdb_ref: string;
  administrative_fee?: EligibilityCheck;
  valuation_fee?: EligibilityCheck;
  current_household_solicitor?: EligibilityCheck;
  proposed_household_solicitor?: EligibilityCheck;
  individuals?: {
     nric: string;
     consent_check: EligibilityCheck;
  }[];

  constructor(initial?: any) {
    this.application_uuid = get(initial, "application_uuid", "")
    this.hdb_ref = get(initial, "hdb_ref", "");
    this.administrative_fee = get(initial, "administrative_fee", undefined);
    this.valuation_fee = get(initial, "valuation_fee", undefined);
    this.current_household_solicitor = get(initial, "current_household_solicitor", undefined);
    this.proposed_household_solicitor= get(initial, "proposed_household_solicitor", undefined);
    this.individuals = get(initial, "individuals", []);
  }
}
